import { render, staticRenderFns } from "./forex-banner.vue?vue&type=template&id=7c720cd4&scoped=true"
import script from "./forex-banner.vue?vue&type=script&lang=js"
export * from "./forex-banner.vue?vue&type=script&lang=js"
import style0 from "./forex-banner.vue?vue&type=style&index=0&id=7c720cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c720cd4",
  null
  
)

export default component.exports